<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i v-if="id" class="right angle icon divider"></i>
    <a v-if="id" class="active" v-on:click="goTo('/corporations')">Corporaciones</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Usuarios</a>
  </div>
  <h1 class="ui header"><i class="icon users"></i>
    <div class="content">Usuarios</div>
  </h1>
  <button v-if="id" class="ui basic button rightButton" v-on:click="goTo('/corporations/'+id+'/users/add')">
    <i class="icon user"></i>Añadir Usuario
  </button>
  <button v-if="!id" class="ui basic button rightButton" v-on:click="goTo('/corporations/users/add')">
    <i class="icon user"></i>Añadir Usuario
  </button>
  <div v-if="!users" class="ui active centered inline loader"></div>
  <div v-if="users" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <table class="ui very basic compact selectable collapsing  table">
          <thead>
            <tr>
              <th class="azpian">Nombre</th>
              <th class="azpian">Apellido</th>
              <th class="azpian">Teléfono</th>
              <th class="azpian">Email</th>
              <th class="azpian">Activo</th>
              <th class="right aligned">
                <div class="ui category search">
                  <div class="ui icon input field">
                    <input class="prompt" type="text" v-model="search" placeholder="Buscar usuario" @change="filteredList">
                    <i class="search icon"></i>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>
                {{user.CorporationsUser.name}}
              </td>
              <td>
                {{user.CorporationsUser.surname}}
              </td>
              <td>
                {{user.CorporationsUser.phone_number}}
              </td>
              <td>
                {{user.CorporationsUser.email}}
              </td>
              <td>
                <h2><i v-if="user.CorporationsUser.active" class="hapiick check icon"></i>
                  <i v-if="!user.CorporationsUser.active" class="red times icon"></i>
                </h2>
              </td>
              <td>
                <div v-if="id" class="ui button" v-on:click="goTo('/corporations/'+id+'/users/' + user.CorporationsUser.id+'/edit')">Editar</div>
                <div v-if="!id" class="ui button" v-on:click="goTo('/corporations/users/' + user.CorporationsUser.id+'/edit')">Editar</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'corporationUsers',
  props: ['id'],
  data() {
    return {
      users: null,
      search: null,
      inputOptions: {},
      token:null,
      parcelId:null,
      role:null
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if (role === 'master' || role === 'admin' || role === 'corporate' || role === 'hmyCorporate') {
      this.role = role;
      this.getCorporationUsers()
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  methods: {
    getCorporationUsers() {
      hapiickApi().post('/v1/corporations/users', {
        admin_id: JSON.parse(localStorage.admin).id,
        corp_id: this.id
      })
      .then(request => {
        this.users = JSON.parse(JSON.stringify(request.data.data.users))
      })
      .catch(() => console.log('error getting companies'))
    },
    filteredList() {
      let userlist = []
      if (this.search.length == 0) {
        this.getCorporationUsers()
      }
      for (var i = 0; i < this.users.length; i++) {
        if (this.users[i].CorporationsUser.name.toLowerCase().includes(this.search.toLowerCase()) || this.users[i].CorporationsUser.surname.toLowerCase().includes(this.search.toLowerCase())) {
          userlist.push(this.users[i])
        }
      }
      this.users = userlist
    },
    goTo(where) {
      this.$router.push(where)
    },
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Corporations/corporationUsers.vue